// FloatingMenu.js
import React, { useEffect, useRef } from "react";
import "./FloatingMenu.css";
import LanguageSelectionMenu from "../../desktop/LanguageSelection_menu";
import { useTranslation } from "react-i18next";
//imagens
import dpp_overlay_logo from "../../../img/logo-dpp-overlay.png";
import logo_citeve from "../../../img/logo_CITEVE_dpp.png";
import prr_rp from "../../../img/prr_rp.png";
import fundo_ambiental from "../../../img/barra-financiamento-beat-barra-v2.png";

const FloatingMenu = ({ isOpen, onClose, touchAreaRef }) => {
  const menuRef = useRef(null);
  const openerRef = useRef(null);
  const onCloseRef = useRef(onClose);
  const languages = ["EN", "PT", /* "DE", "ES", "FR" */];
  const { t } = useTranslation();
  const openLink = (url) => {
    window.open(url, "_blank");
  };



  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  const closeMenu = React.useCallback(() => {
    if (menuRef.current?.open) {
      menuRef.current.close();
    }
    onCloseRef.current();
    window.dispatchEvent(new Event("mobile-menu-closed"));
  }, []);

  useEffect(() => {
    const menu = menuRef.current;

    if (isOpen) {
      openerRef.current = document.activeElement;
      document.body.classList.add("no-scroll");
      if (!menu.open) {
        menu.showModal();
      }
      menu.querySelector(".close-button")?.focus();
    } else {
      document.body.classList.remove("no-scroll");
      if (menuRef.current?.open) {
        menuRef.current.close();
      }
      const opener = openerRef.current;
      openerRef.current = null;
      requestAnimationFrame(() => opener?.focus?.());
    }

    return () => {
      document.body.classList.remove("no-scroll");
      menu?.close();
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleViewportChange = () => {
      if (window.innerWidth >= 768) closeMenu();
    };

    window.addEventListener("resize", handleViewportChange);
    return () => window.removeEventListener("resize", handleViewportChange);
  }, [isOpen, closeMenu]);

  return (
    <div className="container-floating" ref={touchAreaRef}>
      <dialog
        id="mobile-menu"
        className={`floating-menu ${isOpen ? "open" : ""}`}
        ref={menuRef}
        aria-label={t('menu')}
        aria-modal="true"
        onCancel={(event) => {
          event.preventDefault();
          closeMenu();
        }}
        onClick={(event) => {
          if (event.target === event.currentTarget) closeMenu();
        }}
      >
        <div className="floating-menu-content">
          <div className="floating-menu-container">
            <div className="menu-header">
            <LanguageSelectionMenu isHomepage={true} languages={languages} />
            </div>
            <button type="button" className="close-button" onClick={closeMenu}>
              <img
                src="/images/close-icon.svg"
                className="button-close-img"
                alt={t('close')}
              />
            </button>
          </div>
          <ul className="menu-items">
            <li>{t('ABOUT')}</li>
            <li>{t('FAQS')}</li>
            <li>{t('HELP')}</li>
            <li>{t('contacts')}</li>
          </ul>
          <div className="menu-footer">
            {/* Adicionar logos */}
            <img
              src={logo_citeve}
              alt={t('citeve-partnerships')}
              className="supporters-image"
              onClick={() =>
                  openLink("https://www.citeve.pt/")
                }
            />
            <img
              src={prr_rp}
              alt={t('citeve-partnerships')}
              className="supporters-image invert"
            />
            <img
              src={fundo_ambiental}
              alt={t('citeve-partnerships')}
              className="supporters-image invert"
            />
            <img
              src={dpp_overlay_logo}
              alt={t('digital-product-passport')}
              className="dpp-overlay-image"
            />
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default FloatingMenu;
